import { renderRequiredRule } from '@/utils/renderRulesForm';

export default (dataForm) => ({
  typeOfCargo: [renderRequiredRule('Пожалуйста выберите вид')],
  numberOfIdenticalLoads: [renderRequiredRule('Пожалуйста введите количество')],
  cargoVolume: [renderRequiredRule('Пожалуйста введите объём')],
  cargoWeight: [renderRequiredRule('Введите массу')],
  cargoDimensions: [
    {
      validator: (rule, value, callback) => {
        if (
          [dataForm.cargoInformation.sizeOfCargoCylinder.height, dataForm.cargoInformation.sizeOfCargoCylinder.diameter].some((dimension) => Number(dimension) < 10) &&
          dataForm.cargoInformation.typeOfCargo.id === 2
        ) {
          callback(new Error('Каждый габарит минимум 10 см'));
        }
        if ([value.length, value.height, value.width].some((dimension) => Number(dimension) < 10) && dataForm.cargoInformation.typeOfCargo.id === 1) {
          callback(new Error('Каждый габарит минимум 10 см'));
        }
        if (value.length && value.width && value.height && dataForm.cargoInformation.typeOfCargo.id === 1) {
          callback();
        }
        if (dataForm.cargoInformation.sizeOfCargoCylinder.diameter && dataForm.cargoInformation.sizeOfCargoCylinder.height && dataForm.cargoInformation.typeOfCargo.id === 2) {
          callback();
        }
        callback(new Error('Введите габариты'));
      },
      trigger: 'blur',
    },
  ],
  sizeOfCargoCylinder: {
    height: [
      {
        validator: (rule, value, callback) => {
          if (dataForm.cargoInformation.typeOfCargo.id === 2 && value === null) {
            callback(new Error('Введите высоту'));
          }
          callback();
        },
        trigger: 'blur',
      },
    ],
    diameter: [
      {
        validator: (rule, value, callback) => {
          if (dataForm.cargoInformation.typeOfCargo.id === 2 && value === null) {
            callback(new Error('Введите диаметр'));
          }
          callback();
        },
        trigger: 'blur',
      },
    ],
  },
  additionalPackaging: [],
  typeOfPackaging: [
    {
      validator: (rule, value, callback) => {
        if (!dataForm.getCheckRequiredSelected) {
          callback(new Error('Для выбранного характера груза обязательна доп упаковка'));
        }

        callback();
      },
      trigger: 'change',
    },
  ],
  natureOfCargo: [renderRequiredRule('Пожалуйста введите характер', 'change')],
  cargoCost: [renderRequiredRule('Пожалуйста введите стоимость')],

  cashOnDeliverySum: [
    { required: dataForm.cargoInformation.cashOnDelivery, message: 'Введите сумму', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (dataForm.cargoInformation.cashOnDelivery && (value === '' || value.length === 0)) {
          callback(new Error('Введите сумму'));
        }
        callback();
      },
      trigger: 'blur',
    },
    {
      validator: (rule, value, callback) => {
        if (dataForm.cargoInformation.cashOnDelivery && !Number(value)) {
          callback(new Error('Сумма должна быть больше 0'));
        }
        callback();
      },
      trigger: 'blur',
    },
  ],
  cargoRedemptionSum: [
    {
      validator: (rule, value, callback) => {
        if (dataForm.cargoInformation.cargoRedemption && (value === '' || value.length === 0)) {
          callback(new Error('Введите сумму'));
        }
        callback();
      },
      type: Number,
      trigger: 'blur',
    },
    {
      validator: (rule, value, callback) => {
        if (dataForm.cargoInformation.cargoRedemption && !Number(value)) {
          callback(new Error('Сумма должна быть больше 0'));
        }
        callback();
      },
      trigger: 'blur',
    },
  ],
  whoPaysTheRansom: [
    {
      validator: (rule, value, callback) => {
        if (dataForm.cargoInformation.cargoRedemption && !value) {
          callback(new Error('Выберите плательщика'));
        }
        callback();
      },
      trigger: 'change',
    },
  ],

  whoPaysForCargoExtraPacking: [renderRequiredRule('Пожалуйста выберите плательщика', 'change')],
  typeOfPaymentForCargoExtraPacking: [renderRequiredRule('Пожалуйста выберите тип оплаты', 'change')],
});
